import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'allSelector', 'batchButton', 'batchText', 'form']
  static values = {
    selectedIds: { type: Array, default: [] },
    totalCount: Number,
    allIds: { type: Array, default: [] },
    url: String,
    translations: Object
  }

  connect() {
    this.updateBatchButtonVisibility()
    this.updateMenuItemsText()
  }

  reset() {
    this.selectedIdsValue = []
    this.disconnect()
    this.connect()
  }

  toggleRow(event) {
    const rowId = event.target.value
    const isChecked = event.target.checked

    if (isChecked) {
      if (!this.selectedIdsValue.includes(rowId)) {
        this.selectedIdsValue = [...this.selectedIdsValue, rowId]
      }
    } else {
      this.selectedIdsValue = this.selectedIdsValue.filter(id => id !== rowId)
    }

    const allCheckboxesChecked = this.rowTargets.every(
      row => row.querySelector('input[type="checkbox"]').checked
    )
    this.allSelectorTarget.checked = allCheckboxesChecked

    this.updateBatchButtonVisibility()
    this.updateForm()
    this.updateMenuItemsText()
  }

  toggleAll(event) {
    const checked = event.target.checked

    if (checked) {
      const newSelectedIds = this.allIdsValue
        .map(id => id.toString())
        .filter(id => !this.selectedIdsValue.includes(id))

      this.selectedIdsValue = [...this.selectedIdsValue, ...newSelectedIds]
    } else {
      this.selectedIdsValue = []
    }

    this.rowTargets.forEach(row => {
      const checkbox = row.querySelector('input[type="checkbox"]')
      checkbox.checked = checked
    })

    this.updateBatchButtonVisibility()
    this.updateForm()
    this.updateMenuItemsText()
  }

  updateForm() {
    if (this.hasFormTarget) {
      let hiddenField = this.formTarget.querySelector('input[name="ids"]')
      if (hiddenField) {
        hiddenField.value = this.selectedIdsValue.join(',')
      } else {
        hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = 'ids'
        hiddenField.value = this.selectedIdsValue.join(',')
        this.formTarget.appendChild(hiddenField)
      }
    }
  }

  updateBatchButtonVisibility() {
    if (this.hasBatchButtonTarget) {
      if (this.selectedIdsValue.length > 0) {
        this.batchButtonTarget.classList.remove('!hidden')

        if (this.hasbatchTextTarget && this.hasTranslationsValue) {
          const count = this.selectedIdsValue.length
          const template = count === 1 ? this.translationsValue.one : this.translationsValue.other
          this.batchTextTarget.textContent = template.replace('%{count}', count)
        }

        this.updateMenuItemsUrls()
      } else {
        this.batchButtonTarget.classList.add('!hidden')
        if (this.hasbatchTextTarget && this.hasTranslationsValue) {
          this.batchTextTarget.textContent = this.translationsValue.zero
        }
      }
    }
  }

  updateMenuItemsUrls() {
    const menuItems = this.element.querySelectorAll('[data-batch-select-target="batchText"]')
    menuItems.forEach(item => {
      const action = item.dataset.batchSelectAction
      const count = this.selectedIdsValue.length
      if (this.translationsValue[action]) {
        const template =
          count === 1 ? this.translationsValue[action].one : this.translationsValue[action].other
        item.textContent = template.replace('%{count}', count)

        // Find the closest anchor element
        const link = item.closest('a')
        if (link && link.dataset.batchSelectUrlValue) {
          // Get the base URL from the data attribute
          let baseUrl = link.dataset.batchSelectUrlValue

          // Ensure the base URL does not already contain query parameters
          const url = new URL(baseUrl, window.location.origin)
          url.searchParams.delete('ids')

          // Append the selected IDs
          this.selectedIdsValue.forEach(id => {
            url.searchParams.append('ids[]', id)
          })

          // Update the href of the menu item
          link.href = url.toString()
        }
      }
    })
  }

  updateMenuItemsText() {
    const menuItems = this.element.querySelectorAll('[data-batch-select-target="batchText"]')
    menuItems.forEach(item => {
      const action = item.dataset.batchSelectAction
      const count = this.selectedIdsValue.length
      if (this.translationsValue[action]) {
        const template =
          count === 1 ? this.translationsValue[action].one : this.translationsValue[action].other
        item.textContent = template.replace('%{count}', count)
      }
    })
  }
}
